import * as R from 'ramda'

export const findIndexOfId = (value, values) => R.findIndex(R.propEq('id', value))(values)
